export const DEFAULT_COMPONENT_SET_ID = 'ds1';

export const COMPONENT_SET_REGISTRY = Object.freeze([
  Object.freeze({
    setId: 'ds1',
    label: 'Design System',
    version: 1,
    status: 'active',
    themePackIds: ['core-ds1'],
    rendererModulePath: 'src/ui/index.js',
    rendererModule: '../index.js',
    requiredTokensPath: 'src/ui/tokens/required/ds1.required.json',
    optionalTokensPath: 'src/ui/tokens/optional/ds1.optional.json',
    tokenContracts: Object.freeze({
      required: '../tokens/required/ds1.required.json',
      optional: '../tokens/optional/ds1.optional.json'
    })
  }),
  Object.freeze({
    setId: 'ds2',
    label: 'Design System 2',
    version: 2,
    status: 'experimental',
    basedOnSetId: 'ds1',
    themePackIds: ["core-ds1"],
    rendererModulePath: 'src/ui/index.js',
    rendererModule: '../index.js',
    requiredTokensPath: 'src/ui/tokens/required/ds2.required.json',
    optionalTokensPath: 'src/ui/tokens/optional/ds2.optional.json',
    coverageSkeletonPath: 'src/ui/primitives/coverage/ds2.coverage.json',
    tokenContracts: Object.freeze({
      required: '../tokens/required/ds2.required.json',
      optional: '../tokens/optional/ds2.optional.json'
    })
  })
]);

export function listComponentSets() {
  return COMPONENT_SET_REGISTRY.slice();
}

export function getComponentSetDefinition(setId = DEFAULT_COMPONENT_SET_ID) {
  const normalizedSetId = String(setId || '').trim().toLowerCase();
  return (
    COMPONENT_SET_REGISTRY.find((entry) => entry.setId === normalizedSetId)
    || COMPONENT_SET_REGISTRY.find((entry) => entry.setId === DEFAULT_COMPONENT_SET_ID)
    || null
  );
}

export function isComponentSetId(setId) {
  return Boolean(getComponentSetDefinition(setId));
}
